export default "43f6fe5a992d5e3f.svg"